module.exports = __webpack_public_path__ + "static/bootstrap-card-group-090ba9db2d6f8bdfd290c3ad437bd7c6.png";